import { ListPaginationMeta } from "utils/helpers/pagination";

export interface adminPriceTableRow {
  priceTableId: number;
  category: string;
  itemId: number;
  itemName: string;
  unit: string;
  basePrice: number;
  lastUpdatedAt: string;
  toDate: string;
  priceListType: string;
  vendorId: number;
  vendorName: string;
}

export interface AdminTableFormState {
  category: string;
  itemId: string;
  unit: string;
  basePrice: string;
  lastUpdatedAt: string;
  toDate: string;
  priceListType: string;
  vendorId: number;
  vendorName: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<
  "category" | "itemId" | "unit" | "basePrice",
  FieldType
> = {
  category: FieldType.String,
  itemId: FieldType.Number,
  unit: FieldType.String,
  basePrice: FieldType.Number,
};

export type AdminPriceListMeta = ListPaginationMeta;

export type itemNameDropDown = {
  name: string;
  itemId: number;
}

export interface AdminPriceListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: adminPriceTableRow[];
  meta?: AdminPriceListMeta;
}

export interface AdminPriceState {
  loading: boolean;
  priceData: adminPriceTableRow[];
  page: number;
  perPage: number;
  meta: AdminPriceListMeta;
  error: string | null;
  form: AdminTableFormState;
  isAddModalOpen: boolean;
  itemNameDropDown: itemNameDropDown[];
  selectedId: number;
}

